/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";
import { Welcome } from "../components/Welcome";
import { MonthlyContributions } from "../components/MonthlyContributions";
import { RecentFunerals } from "../components/RecentFunerals";
import { RecentDonors } from "../components/RecentDonors";
import { RecentProfilePictures } from "../components/RecentProfilePictures";
import { RecentMemorialWallPosts } from "../components/RecentMemorialWallPosts";
import { WeeklyConsecration } from "../components/WeeklyConsecration";
import { UpcomingFunerals } from "../components/UpcomingFunerals";
import { WeeklyYahrzeit } from "../components/WeeklyYahrzeit";
import { CemeteryOpeningHours } from "../components/CemeteryOpeningHours";
import { Helmet } from "react-helmet";

export const Home: React.FC = () => {
    return(
        <>
            <Helmet>
                <title>Home - Jewish Cemetery</title>
                <meta name="description" content="This website was designed by the Jewish Cemeteries Maintenance Board to pay tribute to loved ones that are no longer with us." />
            </Helmet>

            <div className="jc-grid">
                <div className="row">

                    { (window.innerWidth > 991) &&
                        <>
                            <div className="col-md-6">
                                <Welcome />
                            </div>

                            <div className="col-md-6">
                                <MonthlyContributions endpoint={"transactions/summary/monthToDate"} />
                                <UpcomingFunerals endpoint="deceased/upcoming/burial" recordCount={30} />
                            </div>
                        </>
                    }

                    { (window.innerWidth < 991) &&
                        <>
                            <div className="d-flex justify-content-center" style={{marginBottom: "24px"}}>
                                <img src="/images/jc-gates-image.png" className="w-100" />
                            </div>

                            <div className="col-md-6">
                                <MonthlyContributions endpoint={"transactions/summary/monthToDate"} />
                            </div>

                            <div className="col-md-6">
                                <UpcomingFunerals endpoint="deceased/upcoming/burial" recordCount={30} />
                            </div>
                        </>
                    }

                    <div className="col-md-6">
                        <WeeklyConsecration endpoint={"deceased/upcoming/consecration"} recordCount={30} />
                    </div>

                    <div className="col-md-6">
                        <WeeklyYahrzeit endpoint={"yahrzeit/upcoming"} recordCount={120} />
                    </div>

                    <div className="col-12">
                        <RecentDonors />
                    </div>

                    <div className="col-md-6">
                        <RecentProfilePictures endpoint={"pictures/recent"} pictureType={"PROFILE"} recordCount={30} />
                    </div>

                    <div className="col-md-6">
                        <RecentMemorialWallPosts endpoint={"wallpost/recent"} recordCount={30} />
                    </div>

                    {/* <div className="col-md-6">
                        <WeeklyConsecration endpoint={"deceased/upcoming/consecration"} recordCount={30} />
                    </div> */}

                    <div className="col-md-6">
                        <RecentFunerals endpoint="deceased/recent/burial" />
                    </div>

                    {/* <div className="col-md-6">
                        <WeeklyYahrzeit endpoint={"yahrzeit/upcoming"} recordCount={120} />
                    </div> */}

                    <div className="col-md-6">
                        <CemeteryOpeningHours />
                    </div>
                       
                </div>
            </div>        
        </>
    );
}